import NTopNBottom from '../../components/NTopNBottom'

import navColor from '../../assets/lolita/nav/color.png'
import navBg from '../../assets/lolita/nav/nav_bg.png'
import navBgFixed from '../../assets/lolita/nav/nav_bg_fixed.png'

import far1 from '../../assets/lolita/nav/far1.png'
import far1_active from '../../assets/lolita/nav/far1_active.png'
import far2 from '../../assets/lolita/nav/far2.png'
import far2_active from '../../assets/lolita/nav/far2_active.png'
import far3 from '../../assets/lolita/nav/far3.png'
import far3_active from '../../assets/lolita/nav/far3_active.png'
import son1 from '../../assets/lolita/nav/son1.png'
import son1_active from '../../assets/lolita/nav/son1_active.png'
import son2 from '../../assets/lolita/nav/son2.png'
import son2_active from '../../assets/lolita/nav/son2_active.png'
import son3 from '../../assets/lolita/nav/son3.png'
import son3_active from '../../assets/lolita/nav/son3_active.png'
import son4 from '../../assets/lolita/nav/son4.png'
import son4_active from '../../assets/lolita/nav/son4_active.png'
import son5 from '../../assets/lolita/nav/son5.png'
import son5_active from '../../assets/lolita/nav/son5_active.png'
import son6 from '../../assets/lolita/nav/son6.png'
import son6_active from '../../assets/lolita/nav/son6_active.png'
import bannerImg from '../../assets/lolita/banner.png'

import p1_1 from '../../assets/lolita/ctn/1_1.png'
import p2_1 from '../../assets/lolita/ctn/2_1.png'
import p3_1 from '../../assets/lolita/ctn/3_1.png'
import p4_1 from '../../assets/lolita/ctn/4_1.png'
import p5_1 from '../../assets/lolita/ctn/5_1.png'
import p6_1 from '../../assets/lolita/ctn/6_1.png'

import calcRemFn from '../calcRem'

const PROD_ID = '95072'

const navCss = {
  navWrap: {
    minHeight: calcRemFn(133),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(133),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(133),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    padding: `${calcRemFn(43)} ${calcRemFn(55)} 0`,
    justifyContent: 'space-between'
  },
  topBtnBaseCss: {
    height: calcRemFn(25),
  },
  bottomBtnLayout: {
    padding: `${calcRemFn(8)} ${calcRemFn(100)} 0 ${calcRemFn(100)}`,
  },
  bottomBtnBaseCss: {
    height: calcRemFn(25),
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active,
        prodId: PROD_ID
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active,
        prodId: PROD_ID
      },
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son3,
        img_actived: son3_active,
        prodId: PROD_ID
      },
      {
        key: '_i2',
        show: true,
        img: son4,
        img_actived: son4_active,
        prodId: PROD_ID
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son5,
        img_actived: son5_active,
        prodId: PROD_ID
      },
      {
        key: '_i2',
        show: true,
        img: son6,
        img_actived: son6_active,
        prodId: PROD_ID
      }
    ]
  }
}

const pictures = [
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [
      p1_1,
    ],
    name: '古典-玛德琳'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top1_i2',
    farName: 'top1',
    sonName: '_i2',
    son: [
      p2_1,
    ],
    name: '古典-仙踪'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [
      p3_1,
    ],
    name: '甜美-优格'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top2_i2',
    farName: 'top2',
    sonName: '_i2',
    son: [
      p4_1,
    ],
    name: '甜美-可露丽'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top3_i1',
    farName: 'top3',
    sonName: '_i1',
    son: [
      p5_1,
    ],
    name: '哥特-落影天使'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top3_i2',
    farName: 'top3',
    sonName: '_i2',
    son: [
      p6_1,
    ],
    name: '哥特-月夜舞曲'
  }
]

const topDiff = {
  firstSon: '_i1',
  // top1_i1: 10,
  // top1_i2: -13,
  // top1_i3: -8,
  // top2_i1: 0,
  // top3_i1: 2,
}

export default {
  title: 'Lolita一仲夏物语',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
